const Navigation = [
  { value: "Main", to: "/" },
  { value: "Portfolio", to: "/portfolio" },
  { value: "Services", to: "/services" },
];
export default Navigation;
